import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  DefaultButton,
  MessageBar,
  MessageBarType,
  Panel,
  PanelType,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
  TextField
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';

// functions
import * as ComponentFunctions from './PractitionerAssociationExport.Form.Functions';

// styles
import './PractitionerAssociationExport.Form.Styles.css';

const PractitionerAssociationExportFormComponent = (
  props: ComponentFunctions.Props
) => {
  const [t] = useTranslation();

  const today = new Date().toISOString().split('T')[0];
  const firstOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  )
    .toISOString()
    .split('T')[0];

  const [dateFrom, setDateFrom] = useState<string>(firstOfMonth);
  const [dateTo, setDateTo] = useState<string>(today);
  const [submitted, setSubmitted] = useState<boolean>(false);

  useEffect(() => {
    if (submitted && props.successExportingExcel) {
      setSubmitted(false);
      props.onClose();
    }
  }, [props.successExportingExcel]);

  const handleExport = () => {
    if (!dateFrom || !dateTo) return;
    setSubmitted(true);
    props.ExportPractitionerAssociationsToExcel(dateFrom, dateTo);
  };

  return (
    <Panel
      className="ExportFormPanel"
      isOpen={props.isOpen}
      onDismiss={props.onClose}
      type={PanelType.smallFixedFar}
      headerText={t('practitionerAssociationExport.title')}
      closeButtonAriaLabel={t('common.cancel')}
    >
      <Separator />
      <div className="export-form-field">
        <TextField
          label={t('practitionerAssociationExport.dateFrom')}
          type="date"
          value={dateFrom}
          onChange={(_e, val) => setDateFrom(val || '')}
          required
        />
      </div>
      <div className="export-form-field">
        <TextField
          label={t('practitionerAssociationExport.dateTo')}
          type="date"
          value={dateTo}
          onChange={(_e, val) => setDateTo(val || '')}
          required
        />
      </div>
      {props.failOnExportingExcel && (
        <MessageBar messageBarType={MessageBarType.error}>
          {t('practitionerAssociationExport.exportError')}
        </MessageBar>
      )}
      <div className="export-form-actions">
        <PrimaryButton
          text={
            props.isExportingExcel
              ? t('practitionerAssociationExport.exporting')
              : t('practitionerAssociationExport.exportButton')
          }
          disabled={props.isExportingExcel || !dateFrom || !dateTo}
          onClick={handleExport}
          iconProps={{ iconName: 'ExcelDocument' }}
        />
        <DefaultButton
          text={t('common.cancel')}
          onClick={props.onClose}
          disabled={props.isExportingExcel}
        />
      </div>
      {props.isExportingExcel && (
        <Spinner
          size={SpinnerSize.medium}
          label={t('practitionerAssociationExport.exporting')}
          style={{ marginTop: 16 }}
        />
      )}
    </Panel>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(PractitionerAssociationExportFormComponent as any);
